import { FC } from 'react'
import cn from 'classnames'

import { useMessenger } from '..'
import { MESSAGE_TYPES } from '@/context/constants'
import useDebounce from '@/hooks/useDebounce'

export interface NewMessageButtonProps {
  containerClassName?: string
  className?: string
}

const NewMessageButton: FC<NewMessageButtonProps> = ({
  className,
  containerClassName,
}) => {
  const { sendMessage, getLoading, getConfig } = useMessenger()
  const loading = getLoading()

  const handleOnClick = () => {
    sendMessage({
      type: MESSAGE_TYPES.NEW_CONVERSATION,
    })
  }

  return (
    <div className={cn(containerClassName)}>
      <button
        className={cn('pmui-btn btn-primary', className)}
        onClick={useDebounce(handleOnClick, getConfig()?.debounceTimeout)}
        disabled={loading.conversations}
      >
        New Message
      </button>
    </div>
  )
}

export default NewMessageButton
